import { OrdersDeliveryType, OrdersStatus } from '@/models/orders.model';
import { Roles } from '@/models/admins.model';

export const getHeaderButtonConfig = (
  orderStatus?: OrdersStatus,
  deliveryType?: OrdersDeliveryType,
  role?: Roles | string | null,
) => {
  switch (orderStatus) {
    case OrdersStatus.NEW:
      return {
        label: 'order_details_start_processing_btn',
        nextStatus: OrdersStatus.PROCESSING,
      };
    case OrdersStatus.RESERVE:
      return {
        label: 'order_details_start_processing_btn',
        nextStatus: OrdersStatus.PROCESSING,
      };
    case OrdersStatus.PROCESSING:
      return {
        label: 'order_details_accepted_btn',
        nextStatus: OrdersStatus.ACCEPTED,
      };
    case OrdersStatus.ACCEPTED:
      if (deliveryType === OrdersDeliveryType.NOVA_POSHTA) {
        return {
          label: 'order_details_ready_for_ttn_btn',
          nextStatus: OrdersStatus.READY_FOR_TTN,
        };
      }

      return {
        label: 'order_details_move_to_delivery_btn',
        nextStatus: OrdersStatus.TRANSFERRED,
      };
    case OrdersStatus.READY_FOR_TTN:
      if (
        role === Roles.LOGISTICIAN ||
        role === Roles.SUPER_ADMIN ||
        role === Roles.CLIENT_SERVICE_HEAD ||
        role === Roles.CLIENT_MANAGER
      ) {
        return {
          label: 'order_details_move_to_delivery_btn',
          nextStatus: OrdersStatus.TRANSFERRED,
        };
      }

      return null;
    case OrdersStatus.TRANSFERRED:
      if (deliveryType === OrdersDeliveryType.GOST) {
        return {
          label: 'order_details_completed_btn',
          nextStatus: OrdersStatus.COMPLETED,
        };
      }
      return {
        label: 'order_details_delivered_btn',
        nextStatus: OrdersStatus.AWAITING,
      };
    case OrdersStatus.AWAITING:
      return {
        label: 'order_details_completed_btn',
        nextStatus: OrdersStatus.COMPLETED,
      };
    default:
      return null;
  }
};
